import {useRef} from 'react'
import generateId from '@helpers/misc/generateId'

export default function useIdempotencyKey() {
  const key = useRef(generateId(32))

  return {
    idempotencyKey: key.current,
    regenerateIdempotencyKey: () => {
      key.current = generateId(32)
    }
  }
}
